import { escapeXML } from 'httongue';
import { STATUS_CODES } from 'node:http';
import { dispatchByAccepted } from '../dispatch/dispatch-by-accepted.handler.js';
import { HttpError } from '../http-error.js';
import { Rendering } from './rendering.capability.js';
/**
 * @internal
 */
function errorDetails({ error, response }) {
    let message;
    let details;
    if (error instanceof HttpError) {
        response.statusCode = error.statusCode;
        const { statusMessage } = error;
        if (statusMessage) {
            response.statusMessage = statusMessage;
            message = statusMessage;
        }
        else {
            message = STATUS_CODES[error.statusCode];
        }
        details = error.details;
    }
    else {
        response.statusCode = 500;
        message = 'Internal Server Error';
    }
    return { code: response.statusCode, message, details };
}
/**
 * @internal
 */
function renderHtmlError(context) {
    const details = errorDetails(context);
    const message = details.message ? ' ' + escapeXML(details.message) : '';
    const detailsText = details.details ? escapeXML(details.details) : '';
    context.renderHtml(`<!DOCTYPE html>
<html lang="en">
<head>
<title>ERROR ${details.code}${message}</title>
</head>
<body>
<h1><strong>ERROR ${details.code}</strong>${message}</h1>
<hr/>
${detailsText}
</body>
</html>
`);
}
/**
 * @internal
 */
function renderJsonError(context) {
    context.renderJson({ error: errorDetails(context) });
}
/**
 * HTTP request processing error handler that renders HTML page with error info.
 *
 * Threats {@link HttpError HTTP status error} as HTTP status code to set for error page.
 *
 * Renders either JSON or HTML error page.
 */
export const renderHttpError = /*#__PURE__*/ Rendering.for(
/*#__PURE__*/ dispatchByAccepted({
    'application/json': renderJsonError,
    'text/json': renderJsonError,
    'text/html': renderHtmlError,
    '*/*': renderHtmlError,
}, renderHtmlError));
//# sourceMappingURL=render-http-error.handler.js.map